import React, { useState } from "react";
import { message } from "antd";
import { CiCircleAlert } from "react-icons/ci";
import "./deletemodal.css"; 
import Instance from "../../../AxiosConfig";

const AgentDeleteModal = ({ show, onClose, agentData ,fetchData}) => {
  // const [toastVisible, setToastVisible] = useState(false);

  // const handleDeleteConfirm = () => {
  //   if (onDelete) onDelete();
  //   setToastVisible(true);

  //   // Auto-hide the toast after 3s
  //   setTimeout(() => {
  //     setToastVisible(false);
  //   }, 3000);

  //   // Close the modal
  //   onClose();
  // };
    const handleDelete = async () => {
      try {
        // const token = localStorage.getItem("token");
        const response = await Instance.delete(
          `agents/${agentData._id}` );
  
        if (response.status === 200 || response.status === 201) {
          message.success({
            content: "Agent deleted successfully!",
            duration: 3,
            className: "custom-agent-toast-wrapper",
          });
          onClose();
          fetchData(); // Refresh the agents list
        }
      } catch (error) {
        console.error(error);
        message.error(error.response?.data?.message || "Failed to delete agent.");
      }
    };
  

  return (
    <>
      {show && (
        <div className="delete-modal-overlay" onClick={onClose}>
          <div className="delete-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="alert-content text-center">
              <CiCircleAlert className="alert-icon" />
              <h2>Are you sure?</h2>
              <p>
                Do you really want to delete this file? This action cannot be undone.
              </p>
            </div>
            <div className="d-flex justify-content-around align-items-center gap-3 mt-4">
              <button className="cancel-btn" onClick={onClose}>
                Cancel
              </button>
              <button className="delete-btn" onClick={handleDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Toast Message
      {toastVisible && (
        <div className="custom-ant-toast">
          Agent deleted successfully!
          <span className="toast-close" onClick={() => setToastVisible(false)}>
            ×
          </span>
        </div>
      )} */}
    </>
  );
};

export default AgentDeleteModal;
